import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7b7d90c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = { class: "copy-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "copy-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        "max-height": "575px",
        class: "overflow-y-auto"
      }, {
        default: _withCtx(() => [
          _createElementVNode("pre", { ref: "jsonText" }, _toDisplayString(JSON.stringify(_ctx.metrics, null, 2)), 513)
        ]),
        _: 1
      }),
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_v_btn, { onClick: _ctx.copyToClipboard }, {
          default: _withCtx(() => [
            _createTextVNode("Copy to Clipboard")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (_ctx.showCopyMessage)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass({'copy-message': true, 'error': _ctx.isError})
                }, _toDisplayString(_ctx.message), 3))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_v_card, {
        "max-height": "575px",
        class: "overflow-y-auto"
      }, {
        default: _withCtx(() => [
          _createElementVNode("pre", { ref: "jsonText" }, _toDisplayString(JSON.stringify(_ctx.seats, null, 2)), 513)
        ]),
        _: 1
      }),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_v_btn, { onClick: _ctx.showSeatCount }, {
          default: _withCtx(() => [
            _createTextVNode("Show Assigned Seats count")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (_ctx.showSeatMessage)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass({'copy-message': true, 'error': _ctx.isError})
                }, _toDisplayString(_ctx.message), 3))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}